import "./i18n";
import { BANK_ACCOUNTS_LIST as BASE_BANK_ACCOUNTS_LIST, BANK_ACCOUNTS_CREATE as BASE_BANK_ACCOUNTS_CREATE, BANK_ACCOUNTS_EDIT as BASE_BANK_ACCOUNTS_EDIT, BANK_ACCOUNTS_VIEW as BASE_BANK_ACCOUNTS_VIEW, } from "./config/routes";
import { UserRole } from "@root/api.types";
export const BANK_ACCOUNTS_LIST = {
    ...BASE_BANK_ACCOUNTS_LIST,
};
export const BANK_ACCOUNTS_CREATE = {
    ...BASE_BANK_ACCOUNTS_CREATE,
    roles: [UserRole.ADMIN],
};
export const BANK_ACCOUNTS_EDIT = {
    ...BASE_BANK_ACCOUNTS_EDIT,
    roles: [UserRole.ADMIN],
};
export const BANK_ACCOUNTS_VIEW = {
    ...BASE_BANK_ACCOUNTS_VIEW,
};
